import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import { AuthProvider } from "@/admin/AuthContext";
import { SiteSettingsProvider } from "@/context/SiteSettingsContext";
import { ProtectedRoute } from "@/admin/ProtectedRoute";
import AdminLogin from "@/admin/AdminLogin";
import Dashboard from "@/admin/Dashboard";
import Home from "@/pages/Home";
import About from "@/pages/About";
import WhatWeDo from "@/pages/WhatWeDo";
import TypicalWeek from "@/pages/TypicalWeek";
import HowWeSupport from "@/pages/HowWeSupport";
import FamiliesCarers from "@/pages/FamiliesCarers";
import Safeguarding from "@/pages/Safeguarding";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import AccessibilityStatement from "@/pages/AccessibilityStatement";
import EasyRead from "@/pages/EasyRead";
import NewsList from "@/pages/NewsList";
import NewsDetail from "@/pages/NewsDetail";
import Gallery from "@/pages/Gallery";
import NotFound from "@/pages/NotFound";

function App() {
  useEffect(() => {
    const removeBadge = () =>
      document.querySelectorAll("#emergent-badge").forEach((el) => el.remove());
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <SiteSettingsProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/what-we-do" element={<WhatWeDo />} />
              <Route path="/a-typical-week" element={<TypicalWeek />} />
              <Route path="/how-we-support-people" element={<HowWeSupport />} />
              <Route path="/families-and-carers" element={<FamiliesCarers />} />
              <Route path="/safeguarding-and-complaints" element={<Safeguarding />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
              <Route path="/easy-read" element={<EasyRead />} />
              <Route path="/news" element={<NewsList />} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
          </BrowserRouter>
        </SiteSettingsProvider>
      </AuthProvider>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
